<script>
	import { navigate } from "svelte-routing";

	import LayoutGrid, { Cell } from "@smui/layout-grid";
	import Card, { Content, PrimaryAction } from "@smui/card";

	import {
		loggedin,
		routesById,
		projects,
		selectedProject,
		selectedOrganization,
		organizationProjectSettings,
	} from "../stores";
	import api from "../api";

	// if not logged in, reroute to login
	$: if (!$loggedin) {
		navigate($routesById.login.path);
	}

	$selectedProject = undefined;

	const onProjectClick = async (id) => {
		$selectedProject = id;
		navigate($routesById.graphics.path);
	};
</script>

{#if $loggedin}
	<LayoutGrid fixedColumnWidth>
		{#each $projects as project, i}
			<Cell>
				<Card>
					<PrimaryAction on:click={() => onProjectClick(project.project_id)}>
						<Content class="mdc-typography--body2">
							<h2 class="mdc-typography--headline6" style="margin: 0;">
								{project.name}
							</h2>
							<p>
								{#if project.description}
									{@html project.description}
								{/if}
							</p>
						</Content>
					</PrimaryAction>
				</Card>
			</Cell>
		{/each}
	</LayoutGrid>
{/if}

<style lang="scss">
</style>
